import { render } from "./AddressProgramOrderModalPeriod.vue?vue&type=template&id=636823ce"
import script from "./AddressProgramOrderModalPeriod.vue?vue&type=script&lang=js"
export * from "./AddressProgramOrderModalPeriod.vue?vue&type=script&lang=js"

import "./AddressProgramOrderModalPeriod.vue?vue&type=style&index=0&id=636823ce&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__